var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5556 1.13062C7.177 1.13062 4.44446 3.91284 4.44446 7.35284C4.44446 12.0195 10.5556 18.9084 10.5556 18.9084C10.5556 18.9084 16.6667 12.0195 16.6667 7.35284C16.6667 3.91284 13.9341 1.13062 10.5556 1.13062ZM10.5556 9.57506C9.35081 9.57506 8.37303 8.5795 8.37303 7.35284C8.37303 6.12617 9.35081 5.13062 10.5556 5.13062C11.7603 5.13062 12.7381 6.12617 12.7381 7.35284C12.7381 8.5795 11.7603 9.57506 10.5556 9.57506Z",
    fill: "#FAFAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.5444e63c2abedda8a0c71f725a8811a5.svg";
export { ForwardRef as ReactComponent };